import React from 'react';
import { Avatar } from '@mui/material';

const PALETTE = ['#065F46', '#047857', '#059669', '#0D9488', '#362B24', '#6B5344'];

const avatarBg = (name = '') => {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
};

const initials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "RYF";
  return (parts.length === 1
    ? parts[0][0]
    : parts[0][0] + parts[parts.length - 1][0]
  ).toUpperCase() 
};

const UserAvatar = ({ src, name = '', size = 35, sx, ...props }) => (
  <Avatar
    src={src || undefined}
    sx={{
      width: size,
      height: size,
      bgcolor: src ? undefined : avatarBg(name),
      fontSize: Math.round(size * 0.38),
      fontWeight: 600,
      ...sx,
    }}
    {...props}
  >
    {!src && initials(name)}
  </Avatar>
);

export default UserAvatar;
